import React from 'react';
import { Box, Button } from '@mui/material';
import moment from 'moment';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import SendIcon from '@mui/icons-material/Send';
import AddIcon from '@mui/icons-material/Add';
// import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import { useStringsContext } from '../../../contexts/strings';
import { SchedulePushdNotificationBody } from '../../../types/notification';
import { useUserAuth } from '../../../contexts/auth';
import { ROLES } from '../../../types';

export default function PushNotificationColumn({
  pushNotification,
  onClick,
  abbrv,
}: {
  pushNotification?: SchedulePushdNotificationBody | null;
  onClick: () => void;
  abbrv: string;
}) {
  const { strings } = useStringsContext();
  const pushNotificationId = pushNotification?.id;
  const { isSuperAdmin, hasTeamRole } = useUserAuth();
  const isReadOnly = !isSuperAdmin && hasTeamRole(abbrv, ROLES.VIEWER);
  if (!pushNotificationId) {
    return (
      <Box sx={{ width: '100%' }}>
        <Button
          variant="contained"
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            if (!isReadOnly) {
              onClick();
            }
          }}
          startIcon={<AddIcon />}
          fullWidth
          size="small"
          disabled={isReadOnly}
        >
          {strings.pushNotifications.pushNotificationCreateButton}
        </Button>
      </Box>
    );
  }

  const allowToEdit = pushNotification?.status === 'SCHEDULED' && !isReadOnly;
  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
      <Button
        sx={{
          flex: 1,
          display: 'flex',
          gap: 2,
          cursor: allowToEdit ? 'pointer' : 'default',
          justifyContent: 'flex-start',
        }}
        variant={allowToEdit ? 'outlined' : 'text'}
        fullWidth
        component="div"
        size="small"
        onClick={(event: React.MouseEvent) => {
          event.stopPropagation();
          if (allowToEdit) {
            onClick();
          }
        }}
        disabled={isReadOnly}
      >
        {pushNotification?.scheduledTime && pushNotification?.status === 'SENT' ? (
          <>
            <SendIcon
              sx={{ color: isReadOnly ? 'rgba(0,0,0,0.26)' : '#1B5E20', fontSize: '18px' }}
            />
            <Box sx={{ color: isReadOnly ? 'rgba(0,0,0,0.26)' : '#1B5E20' }}>
              {strings.pushNotifications.statusSent}
            </Box>
          </>
        ) : null}

        {pushNotification?.scheduledTime && pushNotification?.status === 'SCHEDULED' ? (
          <>
            <ScheduleSendIcon
              sx={{ color: isReadOnly ? 'rgba(0,0,0,0.26)' : '#E65100', fontSize: '18px' }}
            />
            <Box sx={{ color: isReadOnly ? 'rgba(0,0,0,0.26)' : '#E65100' }}>
              {strings.pushNotifications.statusScheduled}
            </Box>
          </>
        ) : null}

        {pushNotification?.scheduledTime && pushNotification?.status === 'FAILED' ? (
          <>
            <CancelScheduleSendIcon sx={{ color: 'rgba(0,0,0,0.6)', fontSize: '18px' }} />
            <Box sx={{ color: 'rgba(0,0,0,0.6)' }}>{strings.pushNotifications.statusNotSent}</Box>
          </>
        ) : null}

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            color: isReadOnly ? 'rgba(0,0,0,0.26)' : 'inherit',
          }}
        >
          {pushNotification?.scheduledTime
            ? moment(pushNotification.scheduledTime).format('YYYY-MM-DD HH:mm')
            : null}
        </Box>
      </Button>
    </Box>
  );
}
